<div class="profile">
    <div class="container">
        <div class="row mt-3">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb fqg f18">
                    <li class="mr-3"><img src="/assets/images/icon-yurt.png" alt="home"></li>
                    <li class="breadcrumb-item"><a href="/index" class="mgl">ᠲᠡᠷᠢᠭᠦᠨ ᠨᠢᠭᠤᠷ</a></li>
                    <li class="breadcrumb-item"><a href="/hall-of-fame" class="mgl"> ᠣᠳᠣᠳ ᠤᠨ ᠭᠢᠯᠪᠠᠭ᠎ᠠ</a></li>
                    <li aria-current="page" class="breadcrumb-item active"><span class="mgl">{{pContent.peopleName}}</span></li>
                </ol>
            </nav>
        </div>
        <div class="intro row mt-2 mb-5">
            <div class="col-4">
                <img alt="{{pContent.peopleName}}" class="rounded-sm float-left" src="{{url + pContent.figure}}">
                <h4 class="mgl fgq f24 float-left">{{pContent.peopleName}} ( {{pContent.year}} ) </h4>
            </div>
            <div class="col-8 overflow-auto scrollbar_s" id="scrollX" style="padding-bottom: 35px;">
                <p class="mgl fhw f18"><span class="fgq f18"> ᠲᠣᠪᠴᠢ ᠨᠠᠮᠲᠠᠷ᠄</span> {{pContent.content}}</p>
            </div>
        </div>
        <div class="celebrity container mt-5 mb-5">
            <div class="row justify-content-center"><span class="col lpat"></span>
                <h4 class="col mgl catName justify-content-center fgq"> ᠣᠳᠣᠳ ᠤᠨ ᠭᠢᠯᠪᠠᠭ᠎ᠠ</h4><span class="col lpat"></span></div>
            <div class="row">
                <div class="col-4 col-sm-4 col-md-4 col-lg-2 overflow-hidden" *ngFor="let fl of fameList">
                    <a class="media mgl w-100 mb-4" href="profile/{{ fl.peopleId }}">
                        <h5 class="position-absolute m-0 mr-1 fgq">{{ fl.peopleName }}</h5>
                        <img alt="..." class="align-self-center img-thumbnail w-100" src="{{ url + fl.figure }}">
                        <div class="card-body align-self-center w-100 bg-white">
                            <p class="fqg f18 m-0 w-100 p-0">{{ fl.content }}</p>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>